export default {
    _prefix: "LoadingSpinner",
    loading: "Loading...",
};
